var map = {
	"./AppleMusic.svg": 488,
	"./CopyLinkIcon.svg": 86,
	"./CopyLinkIcon2.svg": 196,
	"./Instagram.svg": 489,
	"./SoundCloud.svg": 490,
	"./Spotify.svg": 491,
	"./Tidal.svg": 492,
	"./TikTok.svg": 493,
	"./Twitter.svg": 494,
	"./Venmo.svg": 495,
	"./YouTube.svg": 496,
	"./activity-icon.svg": 497,
	"./add.svg": 498,
	"./addActive.svg": 79,
	"./affiliations.svg": 499,
	"./affiliationsActive.svg": 500,
	"./attach.svg": 501,
	"./badge.svg": 502,
	"./badges.svg": 197,
	"./cancel-upload.svg": 198,
	"./cheveron-down.svg": 78,
	"./close-arrow-accent.svg": 199,
	"./close-icon.svg": 503,
	"./comments-icon.svg": 259,
	"./connect.svg": 116,
	"./copy.svg": 200,
	"./createFolder.svg": 504,
	"./cross-icon.svg": 47,
	"./cross.svg": 165,
	"./customization.svg": 505,
	"./customizationActive.svg": 506,
	"./data-icon.svg": 260,
	"./deletePermanently.svg": 507,
	"./delete_forever.svg": 508,
	"./down-arrow.svg": 166,
	"./down-icon.svg": 120,
	"./down.svg": 96,
	"./download-share.svg": 107,
	"./download-shared-files-logo.svg": 509,
	"./download-shared-files.svg": 510,
	"./download.svg": 511,
	"./downloaded-white.svg": 201,
	"./downloads.svg": 512,
	"./duplicate.svg": 513,
	"./edit.svg": 202,
	"./electricBolt.svg": 261,
	"./email.svg": 203,
	"./expire.svg": 514,
	"./facebook.svg": 204,
	"./favourite.svg": 68,
	"./files-icon.svg": 262,
	"./folder.svg": 129,
	"./folderActive.svg": 71,
	"./icon-arrow-right.svg": 97,
	"./icon-document.svg": 515,
	"./image-preview.svg": 124,
	"./info.svg": 263,
	"./info_white.svg": 516,
	"./instagram-orange.svg": 517,
	"./integrations.svg": 518,
	"./integrationsActive.svg": 519,
	"./link-icon.svg": 264,
	"./link-playlist.svg": 205,
	"./lock-icon.svg": 520,
	"./login-background.svg": 521,
	"./loop.svg": 206,
	"./messanger.svg": 522,
	"./mic-icon.svg": 523,
	"./move.svg": 524,
	"./orange-filled-star.svg": 167,
	"./pause-play-circle.svg": 168,
	"./pause.svg": 169,
	"./pauseActive.svg": 525,
	"./pausePublic.svg": 93,
	"./pdf.svg": 265,
	"./permanentDelete.svg": 526,
	"./play.svg": 207,
	"./playActive.svg": 527,
	"./playIcon.svg": 208,
	"./playPublic.svg": 125,
	"./playlist-add.svg": 528,
	"./playlist-icon-white.svg": 209,
	"./playlist-icon.svg": 210,
	"./playlist-play-circle.svg": 211,
	"./playlist-tile.svg": 170,
	"./profile-img-accent.svg": 118,
	"./profile-img.svg": 266,
	"./profile.svg": 529,
	"./profileActive.svg": 530,
	"./recording.svg": 212,
	"./reload.svg": 531,
	"./restart.svg": 258,
	"./restore.svg": 532,
	"./rin.svg": 533,
	"./rocket.svg": 534,
	"./session.svg": 213,
	"./sessionCredit.svg": 126,
	"./share.svg": 214,
	"./signup-icon.svg": 130,
	"./soundexchange-icon.svg": 535,
	"./star-icon-outline.svg": 536,
	"./star-icon.svg": 537,
	"./star.svg": 538,
	"./subscription-active.svg": 539,
	"./subscription.svg": 540,
	"./trash-white.svg": 122,
	"./trash.svg": 95,
	"./twitter-orange.svg": 541,
	"./twitter-share.svg": 215,
	"./up-arrow.svg": 171,
	"./up-icon.svg": 119,
	"./upload.svg": 216,
	"./white-outline-star.svg": 54,
	"./youtube-orange.svg": 542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;